// NCAA Schools Database — D1, D2, D3 (2025 Academic Year)
export const ncaaSchools = [

  // ==================== DIVISION I ====================

  // Big Ten Conference (18)
  "University of Illinois at Urbana-Champaign",
  "Indiana University Bloomington",
  "University of Iowa",
  "University of Maryland, College Park",
  "University of Michigan",
  "Michigan State University",
  "University of Minnesota Twin Cities",
  "University of Nebraska-Lincoln",
  "Northwestern University",
  "The Ohio State University",
  "University of Oregon",
  "Pennsylvania State University",
  "Purdue University",
  "Rutgers University",
  "University of California, Los Angeles",
  "University of Southern California",
  "University of Washington",
  "University of Wisconsin-Madison",

  // Atlantic Coast Conference (18)
  "Boston College",
  "University of California, Berkeley",
  "Clemson University",
  "Duke University",
  "Florida State University",
  "Georgia Institute of Technology",
  "University of Louisville",
  "University of Miami",
  "University of North Carolina at Chapel Hill",
  "North Carolina State University",
  "University of Notre Dame",
  "University of Pittsburgh",
  "Southern Methodist University",
  "Stanford University",
  "Syracuse University",
  "University of Virginia",
  "Virginia Polytechnic Institute and State University",
  "Wake Forest University",

  // Big 12 Conference (16)
  "University of Arizona",
  "Arizona State University",
  "Baylor University",
  "Brigham Young University",
  "University of Central Florida",
  "University of Cincinnati",
  "University of Colorado Boulder",
  "University of Houston",
  "Iowa State University",
  "University of Kansas",
  "Kansas State University",
  "Oklahoma State University",
  "Texas Christian University",
  "Texas Tech University",
  "University of Utah",
  "West Virginia University",

  // Southeastern Conference (16)
  "University of Alabama",
  "University of Arkansas",
  "Auburn University",
  "University of Florida",
  "University of Georgia",
  "University of Kentucky",
  "Louisiana State University",
  "University of Mississippi",
  "Mississippi State University",
  "University of Missouri",
  "University of Oklahoma",
  "University of South Carolina",
  "University of Tennessee",
  "Texas A&M University",
  "University of Texas at Austin",
  "Vanderbilt University",

  // Ivy League (8)
  "Brown University",
  "Columbia University",
  "Cornell University",
  "Dartmouth College",
  "Harvard University",
  "University of Pennsylvania",
  "Princeton University",
  "Yale University",

  // Mountain West Conference (12)
  "United States Air Force Academy",
  "Boise State University",
  "Colorado State University",
  "California State University, Fresno",
  "University of Hawaii at Manoa",
  "University of Nevada, Las Vegas",
  "University of Nevada, Reno",
  "University of New Mexico",
  "San Diego State University",
  "San José State University",
  "Utah State University",
  "University of Wyoming",

  // American Athletic Conference (14)
  "University of Alabama at Birmingham",
  "East Carolina University",
  "Florida Atlantic University",
  "University of Memphis",
  "United States Naval Academy",
  "University of North Carolina at Charlotte",
  "University of North Texas",
  "Rice University",
  "University of South Florida",
  "Temple University",
  "University of Texas at San Antonio",
  "Tulane University",
  "University of Tulsa",
  "Wichita State University",

  // Conference USA (10)
  "Florida International University",
  "Jacksonville State University",
  "Kennesaw State University",
  "Liberty University",
  "Louisiana Tech University",
  "Middle Tennessee State University",
  "New Mexico State University",
  "Sam Houston State University",
  "University of Texas at El Paso",
  "Western Kentucky University",

  // Sun Belt Conference (14)
  "Appalachian State University",
  "Coastal Carolina University",
  "Georgia Southern University",
  "Georgia State University",
  "James Madison University",
  "Marshall University",
  "Old Dominion University",
  "Arkansas State University",
  "University of Louisiana at Lafayette",
  "University of Louisiana at Monroe",
  "University of South Alabama",
  "University of Southern Mississippi",
  "Texas State University",
  "Troy University",

  // Mid-American Conference (13)
  "The University of Akron",
  "Ball State University",
  "Bowling Green State University",
  "University at Buffalo",
  "Central Michigan University",
  "Eastern Michigan University",
  "Kent State University",
  "University of Massachusetts Amherst",
  "Miami University",
  "Northern Illinois University",
  "Ohio University",
  "The University of Toledo",
  "Western Michigan University",

  // Atlantic 10 Conference (13)
  "Davidson College",
  "University of Dayton",
  "Duquesne University",
  "Fordham University",
  "George Mason University",
  "George Washington University",
  "La Salle University",
  "Loyola University Chicago",
  "University of Rhode Island",
  "University of Richmond",
  "Saint Joseph's University",
  "Saint Louis University",
  "Virginia Commonwealth University",

  // Big East Conference (11)
  "Butler University",
  "Creighton University",
  "DePaul University",
  "Georgetown University",
  "Marquette University",
  "Providence College",
  "Seton Hall University",
  "St. John's University",
  "University of Connecticut",
  "Villanova University",
  "Xavier University",

  // West Coast Conference (9)
  "Gonzaga University",
  "Loyola Marymount University",
  "University of the Pacific",
  "Pepperdine University",
  "University of Portland",
  "Saint Mary's College of California",
  "University of San Diego",
  "University of San Francisco",
  "Santa Clara University",

  // Big West Conference (9)
  "California Polytechnic State University, San Luis Obispo",
  "California State University, Bakersfield",
  "California State University, Fullerton",
  "California State University, Long Beach",
  "California State University, Northridge",
  "University of California, Davis",
  "University of California, Irvine",
  "University of California, Riverside",
  "University of California, Santa Barbara",

  // Big Sky Conference (11)
  "Eastern Washington University",
  "University of Idaho",
  "Idaho State University",
  "University of Montana",
  "Montana State University",
  "University of Northern Colorado",
  "Northern Arizona University",
  "Portland State University",
  "Sacramento State University",
  "Southern Utah University",
  "Weber State University",

  // ASUN Conference (11)
  "Austin Peay State University",
  "Bellarmine University",
  "University of Central Arkansas",
  "Eastern Kentucky University",
  "Florida Gulf Coast University",
  "Jacksonville University",
  "Lipscomb University",
  "University of North Alabama",
  "University of North Florida",
  "Queens University of Charlotte",
  "Stetson University",

  // Big South Conference (10)
  "Campbell University",
  "Charleston Southern University",
  "Gardner-Webb University",
  "High Point University",
  "Longwood University",
  "North Carolina A&T State University",
  "Presbyterian College",
  "Radford University",
  "University of South Carolina Upstate",
  "Winthrop University",

  // Coastal Athletic Association (12)
  "College of Charleston",
  "University of Delaware",
  "Drexel University",
  "Elon University",
  "Hampton University",
  "Hofstra University",
  "Monmouth University",
  "Northeastern University",
  "Stony Brook University",
  "Towson University",
  "University of North Carolina Wilmington",
  "William & Mary",

  // Horizon League (11)
  "Cleveland State University",
  "University of Detroit Mercy",
  "University of Illinois at Chicago",
  "Indiana University Indianapolis",
  "University of Wisconsin-Milwaukee",
  "Northern Kentucky University",
  "Oakland University",
  "Purdue University Fort Wayne",
  "Robert Morris University",
  "Wright State University",
  "Youngstown State University",

  // Metro Atlantic Athletic Conference (11)
  "Canisius College",
  "Fairfield University",
  "Iona University",
  "Le Moyne College",
  "Manhattan College",
  "Marist College",
  "Niagara University",
  "Quinnipiac University",
  "Rider University",
  "Saint Peter's University",
  "Siena College",

  // Missouri Valley Conference (10)
  "Belmont University",
  "Bradley University",
  "Drake University",
  "University of Evansville",
  "Illinois State University",
  "Indiana State University",
  "Missouri State University",
  "University of Northern Iowa",
  "Southern Illinois University Carbondale",
  "Valparaiso University",

  // Ohio Valley Conference (10)
  "Eastern Illinois University",
  "Lindenwood University",
  "University of Arkansas at Little Rock",
  "Morehead State University",
  "Murray State University",
  "Southeast Missouri State University",
  "Southern Illinois University Edwardsville",
  "University of Tennessee at Martin",
  "Tennessee State University",
  "Tennessee Technological University",

  // Patriot League (9)
  "American University",
  "Army West Point",
  "Boston University",
  "Bucknell University",
  "Colgate University",
  "College of the Holy Cross",
  "Lafayette College",
  "Lehigh University",
  "Loyola University Maryland",

  // Southern Conference (10)
  "The Citadel",
  "East Tennessee State University",
  "Furman University",
  "Mercer University",
  "University of North Carolina at Greensboro",
  "Samford University",
  "University of Tennessee at Chattanooga",
  "Virginia Military Institute",
  "Western Carolina University",
  "Wofford College",

  // Southland Conference (9)
  "Houston Christian University",
  "University of the Incarnate Word",
  "Lamar University",
  "McNeese State University",
  "Nicholls State University",
  "Northwestern State University of Louisiana",
  "Southeastern Louisiana University",
  "Texas A&M University-Corpus Christi",
  "University of New Orleans",

  // Southwestern Athletic Conference (12)
  "Alabama A&M University",
  "Alabama State University",
  "Alcorn State University",
  "University of Arkansas at Pine Bluff",
  "Bethune-Cookman University",
  "Florida A&M University",
  "Grambling State University",
  "Jackson State University",
  "Mississippi Valley State University",
  "Prairie View A&M University",
  "Southern University",
  "Texas Southern University",

  // Mid-Eastern Athletic Conference (8)
  "Coppin State University",
  "Delaware State University",
  "Howard University",
  "University of Maryland Eastern Shore",
  "Morgan State University",
  "Norfolk State University",
  "North Carolina Central University",
  "South Carolina State University",

  // Western Athletic Conference (8)
  "California Baptist University",
  "Chicago State University",
  "Grand Canyon University",
  "Seattle University",
  "Stephen F. Austin State University",
  "Tarleton State University",
  "University of Texas Rio Grande Valley",
  "Utah Valley University",

  // America East Conference (9)
  "University at Albany",
  "Binghamton University",
  "Bryant University",
  "University of Maine",
  "University of Maryland, Baltimore County",
  "University of Massachusetts Lowell",
  "University of New Hampshire",
  "New Jersey Institute of Technology",
  "University of Vermont",

  // Pac-12 (remaining members)
  "Oregon State University",
  "Washington State University",

  // ==================== DIVISION II ====================

  // Pennsylvania State Athletic Conference (PSAC)
  "Bloomsburg University of Pennsylvania",
  "California University of Pennsylvania",
  "Cheyney University of Pennsylvania",
  "Clarion University of Pennsylvania",
  "East Stroudsburg University of Pennsylvania",
  "Edinboro University of Pennsylvania",
  "Gannon University",
  "Indiana University of Pennsylvania",
  "Kutztown University of Pennsylvania",
  "Lock Haven University of Pennsylvania",
  "Mansfield University of Pennsylvania",
  "Mercyhurst University",
  "Millersville University of Pennsylvania",
  "Shippensburg University of Pennsylvania",
  "Slippery Rock University of Pennsylvania",
  "West Chester University of Pennsylvania",
  "University of Pittsburgh at Johnstown",

  // Great Lakes Intercollegiate Athletic Conference (GLIAC)
  "Ashland University",
  "Davenport University",
  "Ferris State University",
  "Grand Valley State University",
  "Lake Superior State University",
  "Michigan Technological University",
  "Northern Michigan University",
  "Northwood University",
  "Purdue University Northwest",
  "Saginaw Valley State University",
  "Wayne State University",

  // Great American Conference (GAC)
  "Arkansas Tech University",
  "University of Arkansas at Monticello",
  "East Central University",
  "Harding University",
  "Henderson State University",
  "Northwestern Oklahoma State University",
  "Oklahoma Baptist University",
  "Ouachita Baptist University",
  "Southeastern Oklahoma State University",
  "Southern Arkansas University",
  "Southern Nazarene University",
  "Southwestern Oklahoma State University",

  // Northern Sun Intercollegiate Conference (NSIC)
  "Augustana University",
  "Bemidji State University",
  "Concordia University St. Paul",
  "Minnesota State University Mankato",
  "Minnesota State University Moorhead",
  "University of Minnesota Crookston",
  "University of Minnesota Duluth",
  "Minot State University",
  "Northern State University",
  "University of Mary",
  "University of Nebraska at Kearney",
  "University of Sioux Falls",
  "Southwest Minnesota State University",
  "Upper Iowa University",
  "Wayne State College",
  "Winona State University",

  // Rocky Mountain Athletic Conference (RMAC)
  "Adams State University",
  "Black Hills State University",
  "Chadron State College",
  "Colorado Mesa University",
  "Colorado School of Mines",
  "Colorado State University Pueblo",
  "Eastern New Mexico University",
  "Fort Lewis College",
  "Metropolitan State University of Denver",
  "New Mexico Highlands University",
  "Regis University",
  "South Dakota School of Mines and Technology",
  "Western Colorado University",

  // California Collegiate Athletic Association (CCAA)
  "California State University, Chico",
  "California State University, Dominguez Hills",
  "California State University, East Bay",
  "California State University, Los Angeles",
  "California State University, Monterey Bay",
  "California State University, San Bernardino",
  "California State University, San Marcos",
  "California State University, Stanislaus",
  "Humboldt State University",
  "Point Loma Nazarene University",
  "San Francisco State University",
  "Sonoma State University",

  // Gulf South Conference (GSC)
  "Christian Brothers University",
  "Delta State University",
  "Mississippi College",
  "University of Montevallo",
  "Shorter University",
  "Trevecca Nazarene University",
  "Union University",
  "University of West Alabama",
  "West Florida University",

  // South Atlantic Conference (SAC)
  "Carson-Newman University",
  "Catawba College",
  "Coker University",
  "Erskine College",
  "Limestone University",
  "Mars Hill University",
  "Newberry College",
  "University of North Carolina at Pembroke",
  "Tusculum University",
  "Wingate University",

  // Central Intercollegiate Athletic Association (CIAA)
  "Bowie State University",
  "Chowan University",
  "Claflin University",
  "Elizabeth City State University",
  "Fayetteville State University",
  "Johnson C. Smith University",
  "Lincoln University of Pennsylvania",
  "Livingstone College",
  "Saint Augustine's University",
  "Shaw University",
  "Virginia State University",
  "Virginia Union University",
  "Winston-Salem State University",

  // Southern Intercollegiate Athletic Conference (SIAC)
  "Albany State University",
  "Benedict College",
  "Clark Atlanta University",
  "Edward Waters University",
  "Fort Valley State University",
  "Kentucky State University",
  "Lane College",
  "LeMoyne-Owen College",
  "Miles College",
  "Morehouse College",
  "Savannah State University",
  "Stillman College",
  "Tuskegee University",

  // Lone Star Conference (LSC)
  "Angelo State University",
  "Cameron University",
  "Lubbock Christian University",
  "Midwestern State University",
  "University of Central Oklahoma",
  "Texas A&M International University",
  "Texas A&M University-Kingsville",
  "University of Texas of the Permian Basin",
  "University of Texas at Tyler",
  "West Texas A&M University",
  "Western New Mexico University",

  // Northeast-10 Conference (NE10)
  "Adelphi University",
  "American International College",
  "Assumption University",
  "Bentley University",
  "Franklin Pierce University",
  "University of New Haven",
  "Pace University",
  "Saint Anselm College",
  "St. Thomas Aquinas College",
  "Southern Connecticut State University",
  "University of Saint Rose",

  // Mountain East Conference
  "Alderson Broaddus University",
  "Bluefield State University",
  "University of Charleston",
  "Concord University",
  "Davis & Elkins College",
  "Fairmont State University",
  "Glenville State University",
  "Notre Dame College",
  "Ohio Valley University",
  "Salem University",
  "Shepherd University",
  "University of Virginia's College at Wise",
  "West Liberty University",
  "West Virginia State University",
  "West Virginia Wesleyan College",
  "Wheeling University",

  // Great Midwest Athletic Conference (G-MAC)
  "Cedarville University",
  "Findlay University",
  "Lake Erie College",
  "Malone University",
  "Ohio Dominican University",
  "Tiffin University",
  "University of Rio Grande",
  "Walsh University",

  // Mid-America Intercollegiate Athletics Association (MIAA)
  "Emporia State University",
  "Fort Hays State University",
  "Missouri Southern State University",
  "Missouri Western State University",
  "Newman University",
  "Northeastern State University",
  "Northwest Missouri State University",
  "Pittsburg State University",
  "Rogers State University",
  "Washburn University",

  // Peach Belt Conference
  "Augusta University",
  "Clayton State University",
  "Columbus State University",
  "Flagler College",
  "Francis Marion University",
  "Georgia College & State University",
  "Georgia Southwestern State University",
  "Lander University",
  "University of North Georgia",
  "University of South Carolina Aiken",
  "Young Harris College",

  // Great Northwest Athletic Conference (GNAC)
  "Central Washington University",
  "Chaminade University of Honolulu",
  "Montana State University Billings",
  "Seattle Pacific University",
  "Simon Fraser University",
  "University of Alaska Anchorage",
  "University of Alaska Fairbanks",
  "Western Oregon University",
  "Western Washington University",

  // Sunshine State Conference (SSC)
  "Barry University",
  "Eckerd College",
  "Florida Institute of Technology",
  "Florida Southern College",
  "Nova Southeastern University",
  "Palm Beach Atlantic University",
  "Rollins College",
  "Saint Leo University",
  "University of Tampa",

  // D2 Other
  "Azusa Pacific University",
  "Biola University",
  "Fresno Pacific University",
  "Lincoln University of Missouri",
  "St. Edward's University",
  "St. Mary's University",
  "University of Jamestown",
  "Wilmington University",

  // ==================== DIVISION III ====================

  // New England Small College Athletic Conference (NESCAC)
  "Amherst College",
  "Bates College",
  "Bowdoin College",
  "Colby College",
  "Connecticut College",
  "Hamilton College",
  "Middlebury College",
  "Trinity College",
  "Tufts University",
  "Wesleyan University",
  "Williams College",

  // University Athletic Association (UAA)
  "Brandeis University",
  "Carnegie Mellon University",
  "Case Western Reserve University",
  "Emory University",
  "New York University",
  "University of Chicago",
  "University of Rochester",
  "Washington University in St. Louis",

  // Centennial Conference
  "Bryn Mawr College",
  "Dickinson College",
  "Franklin & Marshall College",
  "Gettysburg College",
  "Haverford College",
  "Johns Hopkins University",
  "McDaniel College",
  "Muhlenberg College",
  "Swarthmore College",
  "Ursinus College",
  "Washington College",

  // Liberty League
  "Bard College",
  "Clarkson University",
  "Hobart and William Smith Colleges",
  "Ithaca College",
  "Rensselaer Polytechnic Institute",
  "Rochester Institute of Technology",
  "Skidmore College",
  "St. Lawrence University",
  "Union College",
  "Vassar College",

  // Old Dominion Athletic Conference (ODAC)
  "Bridgewater College",
  "Eastern Mennonite University",
  "Emory & Henry College",
  "Guilford College",
  "Hampden-Sydney College",
  "University of Lynchburg",
  "Randolph College",
  "Randolph-Macon College",
  "Roanoke College",
  "Shenandoah University",
  "Virginia Wesleyan University",
  "Washington and Lee University",

  // Minnesota Intercollegiate Athletic Conference (MIAC)
  "Augsburg University",
  "Bethel University",
  "Carleton College",
  "College of Saint Benedict",
  "Concordia College-Moorhead",
  "Gustavus Adolphus College",
  "Hamline University",
  "Macalester College",
  "Saint John's University",
  "Saint Mary's University of Minnesota",
  "Saint Olaf College",
  "University of St. Thomas",
  "College of St. Scholastica",

  // North Coast Athletic Conference (NCAC)
  "Allegheny College",
  "College of Wooster",
  "Denison University",
  "DePauw University",
  "Earlham College",
  "Hiram College",
  "Kenyon College",
  "Oberlin College",
  "Ohio Wesleyan University",
  "Wabash College",

  // Southern Athletic Association (SAA)
  "Berry College",
  "Birmingham-Southern College",
  "Centre College",
  "Hendrix College",
  "Millsaps College",
  "Rhodes College",
  "Sewanee: The University of the South",
  "Trinity University",

  // New Jersey Athletic Conference (NJAC)
  "Kean University",
  "Montclair State University",
  "New Jersey City University",
  "Ramapo College of New Jersey",
  "Rowan University",
  "Rutgers University-Camden",
  "Rutgers University-Newark",
  "Stockton University",
  "William Paterson University",

  // Empire 8
  "Alfred University",
  "Elmira College",
  "Hartwick College",
  "Nazareth University",
  "St. John Fisher University",
  "Stevens Institute of Technology",
  "Utica University",

  // Midwest Conference
  "Beloit College",
  "Cornell College",
  "Grinnell College",
  "Illinois College",
  "Knox College",
  "Lake Forest College",
  "Lawrence University",
  "Monmouth College",
  "Ripon College",
  "Saint Norbert College",

  // Presidents' Athletic Conference
  "Bethany College",
  "Geneva College",
  "Grove City College",
  "Saint Vincent College",
  "Thiel College",
  "Washington & Jefferson College",
  "Waynesburg University",
  "Westminster College",

  // Commonwealth Coast Conference (CCC)
  "Curry College",
  "Eastern Nazarene College",
  "Endicott College",
  "Gordon College",
  "Nichols College",
  "Roger Williams University",
  "Salve Regina University",
  "University of New England",
  "Wentworth Institute of Technology",
  "Western New England University",

  // Southern California Intercollegiate Athletic Conference (SCIAC)
  "California Lutheran University",
  "Chapman University",
  "Claremont McKenna College",
  "Harvey Mudd College",
  "Occidental College",
  "Pitzer College",
  "Pomona College",
  "University of Redlands",
  "Scripps College",
  "Whittier College",

  // SUNY Athletic Conference (SUNYAC)
  "SUNY Brockport",
  "SUNY Cortland",
  "SUNY Fredonia",
  "SUNY Geneseo",
  "SUNY New Paltz",
  "SUNY Oneonta",
  "SUNY Oswego",
  "SUNY Plattsburgh",
  "SUNY Potsdam",

  // New England Women's and Men's Athletic Conference (NEWMAC)
  "Clark University",
  "United States Coast Guard Academy",
  "Emerson College",
  "Massachusetts Institute of Technology",
  "Mount Holyoke College",
  "Smith College",
  "Springfield College",
  "Wellesley College",
  "Wheaton College",
  "Worcester Polytechnic Institute",

  // Additional D3 Schools
  "Babson College",
  "Colorado College",
  "Whitman College",
  "Colby-Sawyer College",
  "Hobart College",
  "Spelman College",
];

export const schoolCounts = {
  divisionI: 365,
  divisionII: 300,
  divisionIII: 427,
  total: 1092,
};

export default ncaaSchools;
